import React from 'react';
import styled from 'styled-components';

import { DefaultTheme, ThemeType } from 'src/packages/theme';
import { Flex } from 'src/packages/core';

export const PaginationWrapper = styled((props) => <Flex {...props} />)<{
  defaulttheme: DefaultTheme;
  themetype: ThemeType;
}>`
  ${({ defaulttheme: { typographyScale, colors } }) => `
      flex-wrap: wrap;
      gap: 6px;
      justify-content: center;
      align-items: center;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      direction: ltr;

      button {
        min-height: 24px;
        min-width: 24px;
        height: auto;
        width: auto;
        padding: 0;
        margin: 0;
        background: transparent;
        border: 0;
        border-radius: 50%;
        span {
          font-size: ${typographyScale.desktop.p3.fontSize};
          color: ${colors.text.primary}
        }
        svg path {
          fill: ${colors.text.primary};
        }  
      }
      button:disabled {
        background: none !important;
        border: 0 !important;
        span {
          color: ${colors.text.disabled};
        }
        svg path {
          fill: ${colors.text.disabled};
        }  
      }
      button:hover:not(:disabled),
      .active {
        background: ${colors.background.inverse};
        border: 0;
        span {
          color: ${colors.text.inverse};
        }
        
        svg path {
          fill: ${colors.text.inverse};
        }  
      }
    `}
`;
